module.exports = __webpack_public_path__ + "img/marca_v.ec5177f7.svg";